/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import {ChangeDetectorRef, Component, ComponentFactoryResolver, OnInit, Renderer2, ViewChild} from '@angular/core';
import {DriverComponent } from './driver-components';
import {DriverComponentContainerDirective} from "./driver-component-container.directive";
import {DriverEditableTable} from "./driver-editable-table/driver-editable-table";


@Component({
    selector: 'GMINSearch',
    providers: [],
    template: `
    <ngx-spinner type="ball-clip-rotate-multiple" bdColor="rgb(0,0,0,0)" color = "#00ff00"></ngx-spinner>
    <div class="input-group">
      <span class="input-group-addon">{{searchLDAPLabel}}</span>

      <input id="searchForDrivers" #searchForDrivers type="text" class="form-control" style="width: 200px; margin-right: 10px;" (keydown.enter)="createComponent('DriverEditableTable', {
        inputs  : { searchFor: searchForDrivers.value},
        outputs : {}
      })" />

      <button id="SubmitSearch" type="button" class="btn btn-secondary" style="padding: 5px 10px;" (click)="createComponent('DriverEditableTable', {
        inputs  : { searchFor: searchForDrivers.value},
        outputs : {}
      })">
        <i class="fa fa-search"></i> Submit
      </button>
      <!--<button id="ResetSearch" type="button" class="btn btn-secondary" style="padding: 5px 10px;" (click)="reloadItems(localParams); searchForDrivers.value='';">-->
      <button id="ResetSearch" type="button" class="btn btn-secondary" style="padding: 5px 10px;" (click)="createComponent('DriverEditableTable', {
        inputs  : { searchFor: ''},
        outputs : { }
      }); searchForDrivers.value=''; searchForDrivers.focus();">
        <i class="fa fa-refresh"></i> Reset
      </button>
      <small style="color: #75446E; padding-left: 10px;">( NOTE : if searching by name, need to provide a full last name )</small>
    </div>
    <ng-container driverComponentContainer></ng-container>
  `,
    standalone: false
})
export class GMINSearchComponent implements OnInit{
  @ViewChild(DriverComponentContainerDirective)
  entryContainer: DriverComponentContainerDirective;

  searchLDAPLabel = "First Name Last Name or GMIN";

  constructor(private cmpFactoryResolver: ComponentFactoryResolver, private render: Renderer2, private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.render.selectRootElement('#searchForDrivers').focus();
  }

  createComponent(name: string, metadata: any) {
    const viewContainerRef = this.entryContainer.viewContainerRef;
    // const cmpClass = driverComponents.find(cmp => cmp.name === name);
    const cmpToCreate = new DriverComponent(DriverEditableTable, metadata);

    const componentFactory = this.cmpFactoryResolver.resolveComponentFactory(cmpToCreate.component);

    viewContainerRef.clear();

    const cmpRef = viewContainerRef.createComponent(componentFactory);


    // patch input values ...
    for ( let input in metadata.inputs ) {
      if ( metadata.inputs.hasOwnProperty(input) ) {
        cmpRef.instance[input] = metadata.inputs[input];
      }
    }


    // and subscribe to outputs
    for ( let output in metadata.outputs ) {
      if ( metadata.outputs.hasOwnProperty(output) ) {
        console.log('hasOuput', metadata.outputs[output]);
        cmpRef.instance[output].subscribe(metadata.outputs[output]);
      }
    }

    this.cdr.detectChanges();
  }

  handleOutput(event) {
    console.log('handle output', event);
  }

  handleOutputAlternative(event) {
    console.log('handle output alternative', event);
  }

}
